/**
 * Tabs
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.js-tabs',

	events: {
		'click .js-tabs-tab': 'onClickTabs',
	},

	initialize() {
		window.addEventListener('resize', this.onResize.bind(this));
	},

	onRender() {
		if (window.innerWidth >= 768) {
			this.setFirstAsDefault();
		}
	},

	setFirstAsDefault() {
		const e = {
			delegateTarget: this.el.querySelector('.js-tabs-tab:first-child'),
		};

		if (!e.delegateTarget.classList.contains('content-visible')) {
			this.onClickTabs(e);
		}
	},

	createDeepClone(element) {
		return element.cloneNode(true);
	},

	onClickTabs(e) {
		const btn = e.delegateTarget;
		const previousVisibleTab = this.el.querySelector('.js-tabs-tab.content-visible');
		const activeBtnClicked = btn.classList.contains('content-visible');

		if (previousVisibleTab) {
			previousVisibleTab.classList.remove('content-visible');
		}
		if (!activeBtnClicked && window.innerWidth < 768) {
			btn.classList.add('content-visible');

			/* Position the active element to the top of the page */
			const distance = window.pageYOffset;
			const offset = btn.getBoundingClientRect().top;
			const menuHeight = document.querySelector('.navigation').offsetHeight;
			window.scroll({
				top: distance + offset - menuHeight,
				left: 0,
				behavior: 'smooth'
			});
		} else if (window.innerWidth >= 768) {
			btn.classList.add('content-visible');
		}

		const selectedTabContent = btn.querySelector('.js-tabs-tab-content');
		const desktopContentContainer = this.el.querySelector('.js-tabs-desktop-content');
		desktopContentContainer.innerHTML = '';
		if (btn.classList.contains('content-visible')) {
			desktopContentContainer.appendChild(this.createDeepClone(selectedTabContent));
		}

	},

	onResize() {
		if (window.innerWidth >= 768) {
			this.setFirstAsDefault();
		}
	},
});

export default View;
